import { Conteudo } from "./../../../../models/pagina/conteudo";
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { ConteudoService } from "../../../../services/conteudo.service";
import { Observable, of, Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { ConfigDialogComponent } from "../../../popups/config-dialog/config-dialog.component";
import { UsuarioEstatisticasService } from "src/app/services/data-services/usuario.estatisticas.service";

@Component({
  selector: "app-cabecalho",
  templateUrl: "./cabecalho.component.html",
  styleUrls: ["./cabecalho.component.scss"],
})
export class CabecalhoComponent implements OnInit, OnDestroy {
  @Input() indexLinhaAtual: number;
  @Input() tituloAtual: string;
  @Input() idLei: string;

  @Output() focoChange = new EventEmitter<number>();

  public exibirApenasItensComentados: boolean;
  public exibirMeusComentarios: boolean;
  public exibirComentariosSvm: boolean;
  public exibirItensRevogados: boolean;
  public prefixoBusca: string;
  public tooltipBusca: string;
  public totalLinhas: number;
  public urlFonteLei: string;
  public isfavorito = false;

  public carregandoConteudo$: Observable<boolean> = of(true);

  private subscriptions = new Array<Subscription>();

  constructor(
    private conteudoService: ConteudoService,
    public dialog: MatDialog,
    private usuarioEstatisticasService: UsuarioEstatisticasService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.conteudoService
        .getConteudo()
        .subscribe((c) => this.conteudoSubscribe(c))
    );

    this.subscriptions.push(
      this.usuarioEstatisticasService
        .getLeisFavoritas()
        .subscribe((fav) => this.favoritosChanged(fav))
    );

    this.carregandoConteudo$ = this.conteudoService.getCarregando();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((x) => x.unsubscribe());
  }

  favoritosChanged(fav: string[]): void {
    if (!fav) {
      return;
    }
    this.isfavorito = fav.indexOf(this.idLei) !== -1;
  }

  public conteudoSubscribe(c: Conteudo) {
    if (!c) {
      return;
    }

    switch (c.tipoDocumento) {
      case 0:
        this.prefixoBusca = "Art. nº";
        this.tooltipBusca = "Buscar pelo número do artigo";
        break;
      case 1:
        this.prefixoBusca = "Súm. nº";
        this.tooltipBusca = "Buscar pelo número da súmula";
        break;
      case 2:
        this.prefixoBusca = "Art. nº";
        this.tooltipBusca = "Buscar pelo número do artigo";
        break;
      default:
        this.prefixoBusca = "";
        this.tooltipBusca = "";
        break;
    }

    this.totalLinhas = c.linhas.length;
    this.urlFonteLei = c.urlFonteLei;

    this.checkFavoritos();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ConfigDialogComponent, {
      width: "280px",
      data: {},
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  public async favoritoAlterardo() {
    const estatisticas = await this.usuarioEstatisticasService.marcarFavorito(
      this.idLei
    );
    this.isfavorito = estatisticas.favorito;
  }

  private async checkFavoritos() {
    const estatistica = await this.usuarioEstatisticasService.buscar(
      this.idLei
    );
    this.isfavorito = estatistica.favorito ? true : false;
  }
  public ArtigoFinal() {
    this.focoChange.emit(this.totalLinhas - 10);
  }
  public ArtigoInicial() {
    this.focoChange.emit(0);
  }
}
